import { selfGuidedTourAvailableDates } from 'constants/routes';

/**
 * Retrieves the self-guided tour dates based on the provided payload.
 * @param {Object} payload.
 * @param {string} payload.specId.
 * @param {Date} [payload.startDate] - Optional start date for filtering (if present `payload.endDate is required).
 * @param {Date} [payload.endDate] - Optional end date for filtering (if present `payload.startDate` is required).
 * @returns {Observable}.
 */

function getAvailableTourDates(payload) {
  const url = `${selfGuidedTourAvailableDates}?specId=${payload.specId}`;

  const finalUrl = (payload.startDate && payload.endDate)
    // we need to remove the Z from the date string because the API treats it as a UTC date
    // and applies the server local timezone offset to it changing the date
    ? `${url}&startDate=${payload.startDate.toISOString().replace('Z', '')}&endDate=${payload.endDate.toISOString().replace('Z', '')}`
    : url;

  return fetch(finalUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  }).then((response) => response.json());
}

export default getAvailableTourDates;
